<template>
  <div class="species-side-page">
    <div class="header-breadcrumb">
      <p class="fir-text" @click="toSpecies('1')">物种数据</p>
      <p class="mid-text">&lt;</p>
      <p>{{ headerTitle }}</p>
    </div>
    <div class="content">
      <div class="top">
        <div class="top-left">
          <el-upload
            class="avatar-uploader"
            action="/"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="fileHandleChange"
            accept=".png,.jpg,.jpeg"
          >
            <div class="up-img">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <p>选择封面</p>
              </div>
            </div>
          </el-upload>
          <div class="is-open">
            <span>是否公开</span>
            <el-switch
              v-model="isOpenValue"
              active-color="#05579E"
              inactive-color="#DDDDDD"
            >
            </el-switch>
          </div>
        </div>
        <div class="base-mes">
          <p class="base-top" :class="{ require: isOpenValue }">基本信息</p>
          <div class="base-title">
            <span>类型</span>
            <span>种</span>
          </div>
          <div class="base-content">
            <el-form
              label-position="left"
              label-width="100px"
              :model="baseFormList"
            >
              <el-form-item label="界">
                <el-input
                  v-model="baseFormList.kingdom"
                  placeholder="请输入界"
                ></el-input>
              </el-form-item>
              <el-form-item label="门">
                <el-input
                  v-model="baseFormList.door"
                  placeholder="请输入门"
                ></el-input>
              </el-form-item>
              <el-form-item label="纲">
                <el-input
                  v-model="baseFormList.outline"
                  placeholder="请输入纲"
                ></el-input>
              </el-form-item>
              <el-form-item label="目">
                <el-input
                  v-model="baseFormList.order"
                  placeholder="请输入目"
                ></el-input>
              </el-form-item>
              <el-form-item label="科">
                <el-input
                  v-model="baseFormList.section"
                  placeholder="请输入科"
                ></el-input>
              </el-form-item>
              <el-form-item class="genus-item">
                <span slot="label" :class="{ require: !isOpenValue }">属</span>
                <el-select
                  v-model="genusSelectValue"
                  filterable
                  placeholder="请输入关键词"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in genusList"
                    :key="item.genusId"
                    :label="item.genusName"
                    :value="item.genusId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="middle">
        <el-form label-position="left" :model="midFormList">
          <el-form-item class="inline name" label-width="80px">
            <span slot="label" class="require">名称</span>
            <el-input
              v-model="midFormList.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item class="inline name" label-width="60px">
            <span slot="label">同义名</span>
            <el-input
              v-model="midFormList.synonymousName"
              placeholder="请输入同义名"
            ></el-input>
          </el-form-item>
          <el-form-item class="inline" label-width="120px">
            <span slot="label" class="require">数据库编号</span>
            <el-input
              v-model="midFormList.databaseCode"
              placeholder="请输入数据库编号"
            ></el-input>
          </el-form-item>
          <el-form-item class="inline" label-width="120px">
            <span slot="label" class="require">NCBI物种编号</span>
            <el-input
              v-model="midFormList.code"
              placeholder="请输入物种编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="生活环境" class="environment" label-width="80px" style="margin-bottom:19px;">
            <el-input
              v-model="midFormList.environment"
              type="textarea"
              :rows="2"
              placeholder="请输入生活环境"
            ></el-input>
          </el-form-item>
          <el-form-item label="地理位置" class="environment" label-width="80px">
            <el-input
              v-model="midFormList.geographicLocation"
              type="textarea"
              :rows="2"
              placeholder="请输入地理位置"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="download">
        <div class="down-box down-left">
          <p>
            基因组序列下载
            <el-tooltip
              class="item"
              effect="dark"
              content="此操作不可取消"
              placement="top"
            >
              <svg
                t="1647932228140"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4861"
                width="16"
                height="16"
              >
                <path
                  d="M512 64a448 448 0 1 0 448 448 448 448 0 0 0-448-448z m3.2 704a48 48 0 0 1-48-47.36 48.64 48.64 0 0 1 48-48 48 48 0 0 1 47.36 48 47.36 47.36 0 0 1-47.36 47.36z m80.64-271.36A131.84 131.84 0 0 0 547.84 576v32a33.28 33.28 0 0 1-64 0v-24.32a181.76 181.76 0 0 1 67.2-120.32 165.76 165.76 0 0 0 60.16-104.96 83.2 83.2 0 0 0-90.24-89.6c-64 0-99.84 41.6-101.76 119.68a32 32 0 0 1-31.36 28.8 31.36 31.36 0 0 1-30.72-28.8V384a154.24 154.24 0 0 1 163.84-166.4 135.04 135.04 0 0 1 147.2 140.8 196.48 196.48 0 0 1-72.32 138.24z"
                  p-id="4862"
                ></path>
              </svg>
            </el-tooltip>
          </p>
          <div class="upload" v-if="sequenceFile === null">
            <el-upload
              class="sequence-upload"
              drag
              action="/"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="sequenceUpLoad"
              accept=".genomic.fna.gz"
            >
              <img src="@/assets/img/upload.svg" alt="upload" />
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
          <div
            v-if="loading"
            style="height:162px"
            v-loading="loading"
            element-loading-text="文件上传中"
            element-loading-spinner="el-icon-loading"
          ></div>
          <div class="upload-suc" v-if="sequenceFile !== null && !loading">
            <div class="svg-box" @click="delSequenceFile">
              <i class="el-icon-circle-close"></i>
            </div>
            <img src="../../../assets/img/down-file.svg" alt="" />
            <p>{{ sequenceFile && sequenceFile.name }}</p>
          </div>
        </div>
        <!-- <div class="down-box down-right">
          <p>镜检结果</p>
          <div class="upload" v-if="microscopicFile === null">
            <el-upload
              class="sequence-upload"
              drag
              action="/"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="microscopicUpLoad"
              accept=".png,.jpg,.jpeg"
            >
              <img src="@/assets/img/upload.svg" alt="upload" />
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
          <div class="upload-suc" v-else>
            <div class="svg-box" @click="delMicroscopicFile">
              <i class="el-icon-circle-close"></i>
            </div>
            <img src="../../../assets/img/down-file.svg" alt="" />
            <p>{{ microscopicFile && microscopicFile.name }}</p>
          </div>
        </div> -->
      </div>
      <div class="reference">
        <p>参考文献</p>
        <div>
          <div class="reference-list">
            <div v-for="(item, index) in referenceList" :key="item.index">
              <span class="order-number">[{{ index + 1 }}]</span>
              <el-input
                v-model="item.text"
                @blur="getReferenceChange(index)"
              ></el-input>
            </div>
          </div>
          <el-input
            v-if="referenceAdd"
            v-model="referenceInput"
            placeholder="请输入"
            @keyup.enter.native="addReferenceChange"
            @blur="addReferenceChange"
            ref="referenceInput"
          ></el-input>
          <div class="reference-add" @click="addReferenceClick">
            <i class="el-icon-circle-plus-outline"></i>
            <span>点击添加文献</span>
          </div>
        </div>
      </div>
      <button v-if="newBuild === true" @click="saveClick">新建物种</button>
      <button v-else @click="saveClick">保存</button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { Message } from 'element-ui'
export default {
  name: 'SpeciesSidePage',
  data () {
    return {
      imageUrl: '',
      imageRaw: null,
      isOpenValue: false,
      speciesId: '',
      baseFormList: {
        door: '',
        outline: '',
        order: '',
        section: '',
        kingdom: ''
      },
      midFormList: {
        name: '',
        synonymousName: '',
        code: '',
        databaseCode: '',
        environment: '',
        geographicLocation: ''
      },
      sequenceFile: null,
      // microscopicFile: null,
      referenceList: [],
      delReferenceList: [],
      referenceInput: '',
      referenceAdd: false,
      genusList: [],
      genusSelectValue: '',
      newBuild: null,
      succObj: {
        addReference: false,
        delReference: false,
        modReference: false,
        img: false,
        file: false
      },
      loading: false,
      headerTitle: '',
      speciesDatabaseId: ''
    }
  },
  created () {
    api.genusChoice().then(res => {
      if (res.data.code === 200) {
        this.genusList = res.data.data
      } else {
        Message.error(`${res.data.msg}`)
      }
    })
    if (this.$route.query.id === undefined) {
      this.newBuild = true
      this.headerTitle = '新建物种'
    } else {
      this.newBuild = false
      this.speciesListById(this.$route.query.id)
    }
    this.getSettingData()
  },
  methods: {
    async getSettingData () {
      let url = '../../static/geneIdSetting.json'
      try {
        let response = await fetch(url)
        let obj = await response.json()
        this.speciesDatabaseId = obj.speciesDatabaseId
      } catch (error) {
        // console.log('Request Failed', error)
      }
    },
    toSpecies (val = null) {
      if (val) {
        this.$router.push({
          name: 'Species',
          params: this.$route.params
        })
      } else {
        if (this.newBuild) {
          Message.success('新建成功')
          this.$router.push('/species')
        } else {
          Message.success('修改成功')
          this.$router.push({
            name: 'Species',
            params: this.$route.params
          })
        }
      }
    },
    // 获取物种详情
    speciesListById (id) {
      api.speciesListById(id).then(res => {
        if (res.data.code === 200) {
          this.headerTitle = res.data.data.species.speciesName
          this.imageUrl = res.data.data.species.imgCode
          this.speciesId = res.data.data.species.speciesId
          this.midFormList['name'] = res.data.data.species.speciesName
          this.midFormList['synonymousName'] =
            res.data.data.species.synonymousName
          this.midFormList['code'] = res.data.data.species.speciesCode
          this.midFormList['databaseCode'] = res.data.data.species.databaseCode
          this.midFormList['environment'] = res.data.data.species.environment
          this.midFormList['geographicLocation'] = res.data.data.species.geographicLocation
          this.baseFormList['door'] = res.data.data.species.phylum
          this.baseFormList['outline'] = res.data.data.species.outline
          this.baseFormList['order'] = res.data.data.species.catalogue
          this.baseFormList['section'] = res.data.data.species.family
          this.baseFormList['kingdom'] = res.data.data.species.kingdom
          this.genusSelectValue = res.data.data.species.genusId
          res.data.data.species.isOpen === 'Yes'
            ? (this.isOpenValue = true)
            : (this.isOpenValue = false)
          if (res.data.data.genomeSequenceList.length !== 0) {
            this.sequenceFile = res.data.data.genomeSequenceList[0]
            this.sequenceFile.name = res.data.data.genomeSequenceList[0].sfName
          }
          // if (res.data.data.microscopyResultsList.length !== 0) {
          //   this.microscopicFile = res.data.data.microscopyResultsList[0]
          //   this.microscopicFile.name =
          //     res.data.data.microscopyResultsList[0].sfName
          // }
          if (res.data.data.literatureList.length !== 0) {
            res.data.data.literatureList.forEach(ele => {
              let obj = {}
              obj.literatureId = ele.literatureId
              obj.text = ele.literatureName
              obj.state = 'original'
              this.referenceList.push(obj)
            })
          }
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    fileHandleChange (file) {
      // 限制图片上传的大小格式
      const fileType = file.name.substring(file.name.lastIndexOf('.'))
      const isFileType = fileType === '.jpg' || fileType === '.png'
      const isLt2M = file.size / 1024 < 100
      if (!isFileType) {
        Message.error('上传头像图片只能是 png 或 jpg 格式!')
      }
      if (!isLt2M) {
        Message.error('上传头像图片大小不能超过 100k!')
      }
      if (isFileType && isLt2M) {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.imageRaw = file.raw
      }
    },
    // 基因组上传文件
    sequenceUpLoad (file) {
      this.sequenceFile = file
      if (this.newBuild === false) {
        this.checkByspeciesFile(this.speciesId, 'sequence')
      }
    },
    // 镜检上传文件
    // microscopicUpLoad (file) {
    //   this.microscopicFile = file
    //   if (this.newBuild === false) {
    //     this.checkByspeciesFile(this.speciesId, 'microscopic')
    //   }
    // },
    // 基因组删除文件
    delSequenceFile () {
      if (this.newBuild === false) {
        this.deleteFileBySpecies(this.sequenceFile.sfId, 'sequence')
      } else {
        this.sequenceFile = null
      }
    },
    // 镜检删除文件
    // delMicroscopicFile () {
    //   if (this.newBuild === false) {
    //     this.deleteFileBySpecies(this.microscopicFile.sfId, 'microscopic')
    //   }
    // },
    // 文件删除
    deleteFileBySpecies (id, val) {
      api.deleteFileBySpecies(id).then(res => {
        if (res.data.code === 200) {
          Message.success(`${res.data.msg}`)
          // if (val === 'microscopic') {
          //   this.microscopicFile = null
          // }
          if (val === 'sequence') {
            this.sequenceFile = null
          }
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 文献
    getReferenceChange (index) {
      if (this.referenceList[index].text.length === 0) {
        this.delReferenceList.push(this.referenceList[index])
        this.referenceList.splice(index, 1)
      }
    },
    addReferenceClick () {
      if (!this.referenceAdd) {
        this.referenceAdd = true
        this.$nextTick(() => {
          this.$refs.referenceInput.focus()
        })
      }
    },
    addReferenceChange () {
      if (this.referenceInput !== '') {
        let obj = {}
        obj.state = 'new'
        obj.text = this.referenceInput
        this.referenceList.push(obj)
        this.referenceInput = ''
      }
      this.referenceAdd = false
    },
    // 检验是否公开的必填信息
    ConfirmIsOpen () {
      if (this.isOpenValue === true) {
        // 公开，基础信息、名称、编号必填
        for (let key in this.baseFormList) {
          if (this.baseFormList[key] === '') {
            Message('请填写必填项')
            return false
          }
        }
        if (
          this.genusSelectValue &&
          this.midFormList.name &&
          this.midFormList.databaseCode &&
          this.midFormList.code
        ) {
          return true
        } else {
          Message('请填写必填项')
          return false
        }
      } else {
        // 不公开，属、名称、编号必填
        if (
          this.genusSelectValue &&
          this.midFormList.name &&
          this.midFormList.databaseCode &&
          this.midFormList.code
        ) {
          return true
        } else {
          Message('请填写必填项')
          return false
        }
      }
    },
    // 确定信息
    saveClick () {
      let a = this.ConfirmIsOpen()
      if (a) {
        if (this.newBuild === true) {
          // 新建物种
          this.speciesInsert()
        } else {
          // 修改物种
          this.speciesUpdate()
        }
      }
    },
    // 修改物种信息
    speciesUpdate () {
      let obj = {}
      obj.speciesId = this.speciesId
      obj.speciesName = this.midFormList.name
      obj.synonymousName = this.midFormList.synonymousName
      obj.databaseCode = this.midFormList.databaseCode
      obj.speciesCode = this.midFormList.code
      obj.environment = this.midFormList.environment
      obj.geographicLocation = this.midFormList.geographicLocation
      obj.speciesType = '种'
      obj.phylum = this.baseFormList.door
      obj.outline = this.baseFormList.outline
      obj.catalogue = this.baseFormList.order
      obj.family = this.baseFormList.section
      obj.kingdom = this.baseFormList.kingdom
      obj.genusId = this.genusSelectValue
      this.isOpenValue === true ? (obj.isOpen = 1) : (obj.isOpen = 0)
      api.speciesUpdate(obj).then(res => {
        if (res.data.code === 200) {
          this.speciesUpdataImage(this.speciesId)
          this.judgeLiteratureState(this.speciesId)
          // Message.success(`${res.data.msg}`)
          this.succObj.file = true
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 新建物种信息
    speciesInsert () {
      let obj = {}
      obj.speciesName = this.midFormList.name
      obj.synonymousName = this.midFormList.synonymousName
      obj.speciesCode = this.midFormList.code
      obj.databaseCode = this.midFormList.databaseCode
      obj.environment = this.midFormList.environment
      obj.geographicLocation = this.midFormList.geographicLocation
      obj.speciesType = '种'
      obj.phylum = this.baseFormList.door
      obj.outline = this.baseFormList.outline
      obj.catalogue = this.baseFormList.order
      obj.family = this.baseFormList.section
      obj.kingdom = this.baseFormList.kingdom
      obj.genusId = this.genusSelectValue
      this.isOpenValue === true ? (obj.isOpen = 1) : (obj.isOpen = 0)
      api.speciesInsert(obj).then(res => {
        if (res.data.code === 200) {
          this.speciesUpdataImage(res.data.data)
          this.judgeLiteratureState(res.data.data)
          this.checkByspeciesFile(res.data.data)
          // Message.success(`${res.data.msg}`)
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 添加图片
    speciesUpdataImage (id) {
      if (this.imageRaw) {
        let FileRaw = new FormData()
        FileRaw.append('file', this.imageRaw)
        api.speciesUpdataImage(id, FileRaw).then(res => {
          if (res.data.code === 200) {
            this.succObj.img = true
          } else {
            Message.error(`${res.data.msg}`)
          }
        })
      } else {
        this.succObj.img = true
      }
    },
    // 判断文献的删除或添加或修改
    judgeLiteratureState (speciesId) {
      if (this.referenceList.length !== 0) {
        let newList = []
        let modifyList = []
        this.referenceList.forEach(item => {
          if (item.state === 'new') {
            let obj = {}
            obj.speciesId = speciesId
            obj.literatureName = item.text
            newList.push(obj)
          } else {
            let obj = {}
            obj.literatureId = item.literatureId
            obj.literatureName = item.text
            modifyList.push(obj)
          }
        })
        this.literatureInsert(newList)
        this.modifyByLiterature(modifyList)
      } else {
        this.succObj.addReference = true
        this.succObj.modReference = true
      }
      if (this.delReferenceList.length !== 0) {
        this.deleteByLiterature(this.delReferenceList)
      } else {
        this.succObj.delReference = true
      }
    },
    // 添加文献
    literatureInsert (list) {
      if (list.length !== 0) {
        let suNum = 0
        list.forEach(item => {
          api.literatureInsert(item).then(res => {
            if (res.data.code === 200) {
              // Message.success(`${res.data.msg}`)
            } else {
              Message.error(`${res.data.msg}`)
            }
            suNum++
            if (suNum === list.length) {
              this.succObj.addReference = true
            }
          })
        })
      } else {
        this.succObj.addReference = true
      }
    },
    // 修改文献
    modifyByLiterature (list) {
      if (list.length !== 0) {
        list.forEach(item => {
          let suNum = 1
          api.modifyByLiterature(item).then(res => {
            if (res.data.code === 200) {
              // Message.success(`${res.data.msg}`)
            } else {
              Message.error(`${res.data.msg}`)
            }
            suNum++
            if (suNum === list.length) {
              this.succObj.modReference = true
            } else {
            }
          })
        })
      } else {
        this.succObj.modReference = true
      }
    },
    // 删除文献
    deleteByLiterature (list) {
      if (list.length !== 0) {
        let sucNum = 0
        for (let i = 0; i < list.length; i++) {
          if (list[i].literatureId) {
            api.deleteByLiterature(list[i].literatureId).then(res => {
              if (res.data.code === 200) {
                // Message.success(`${res.data.msg}`)
              } else {
                Message.error(`${res.data.msg}`)
              }
              sucNum++
              if (sucNum === list.length) {
                this.succObj.delReference = true
              }
            })
          }
        }
        // list.forEach((item, index) => {
        //   if (item.literatureId) {
        //     api.deleteByLiterature(item.literatureId).then(res => {
        //       if (res.data.code === 200) {
        //         // Message.success(`${res.data.msg}`)
        //       } else {
        //         Message.error(`${res.data.msg}`)
        //       }
        //     })
        //   }
        // })
      } else {
        this.succObj.delReference = true
      }
    },
    // 文件查重
    checkByspeciesFile (id, val = null) {
      if (!this.sequenceFile) {
        //  && !this.microscopicFile
        this.succObj.file = true
        return false
      } else {
        let list = []
        if (val === 'sequence') {
          this.sequenceFile && list.push(this.sequenceFile.name)
        } else {
          this.sequenceFile && list.push(this.sequenceFile.name)
          // this.microscopicFile && list.push(this.microscopicFile.name)
        }
        // else if (val === 'microscopic') {
        //   this.microscopicFile && list.push(this.microscopicFile.name)
        // }
        this.loading = true
        api.checkByspeciesFile(id, list).then(res => {
          if (res.data.code === 200) {
            if (res.data.data.repeat.length === 0) {
              // 无重复，上传文件
              this.classifyAndUploading(id, val)
            } else {
              // 有重复,是否覆盖,基本不出现
              this.checkFileByAnnotation(res.data.data.repeat, id)
            }
          } else {
            Message.error(`${res.data.msg}`)
            this.succObj.file = true
          }
        })
      }
    },
    // 文件是否覆盖,删除接口
    checkFileByAnnotation (repeat, id) {
      let name = ''
      repeat.forEach((item, index) => {
        if (index !== 0) {
          name += ','
        }
        name += item.name
      })
      this.$confirm(`${name}文件已存在，是否覆盖`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'ele-tip-confirm-btn',
        cancelButtonClass: 'ele-tip-cancel-btn',
        type: 'warning'
      })
        .then(() => {
          // 调用删除接口
          let index = 0
          const recursion = index => {
            if (index < repeat.length) {
              api.deleteFileBySpecies(repeat[index].number).then(res => {
                if (res.data.code === 200) {
                  Message({
                    type: 'success',
                    message: '已覆盖!'
                  })
                } else {
                  Message.error(`${res.data.msg}`)
                }
                index++
                recursion()
              })
            } else {
              // 删除成功，文件上传
              this.classifyAndUploading(id)
            }
          }
          recursion(index)
        })
        .catch(() => {
          // 将原本list的文件删除
          repeat.forEach(item => {
            if (item.name === this.sequenceFile.name) {
              this.sequenceFile = ''
            }
            // if (item.name === this.microscopicFile.name) {
            //   this.microscopicFile = ''
            // }
          })
          Message({
            type: 'info',
            message: '不覆盖'
          })
          this.loading = false
        })
    },
    // 文件上传
    classifyAndUploading (id, val = null) {
      let FileRaw = new FormData()
      if (val === 'sequence') {
        FileRaw.append('files', this.sequenceFile.raw)
      } else {
        FileRaw.append('files', this.sequenceFile.raw)
        // FileRaw.append('files', this.microscopicFile.raw)
      }
      // else if (val === 'microscopic') {
      //   FileRaw.append('files', this.microscopicFile.raw)
      // }
      if (!this.speciesDatabaseId) {
        return Message.error('找不到数据库id')
      }
      api.classifyAndUploading(this.speciesDatabaseId, FileRaw).then(res => {
        if (res.data.code === 200) {
          this.updataSpeciesFile(id, res.data.data, val)
        } else {
          if (val === 'sequence') {
            this.sequenceFile = ''
          } else {
            this.sequenceFile = ''
            // this.microscopicFile = ''
          }
          // else if (val === 'microscopic') {
          //   this.microscopicFile = ''
          // }
          Message.error(`${res.data.msg}`)
          this.succObj.file = true
          this.loading = false
        }
      })
    },
    // 更新信息
    updataSpeciesFile (id, data, val = null) {
      api.updataSpeciesFile(id, data).then(res => {
        if (res.data.code === 200) {
          if (val === 'sequence') {
            this.sequenceFile.sfId = res.data.data
          }
          Message.success(`${res.data.msg}`)
          // if (val === 'microscopic') {
          //   this.microscopicFile.sfId = res.data.data
          // }
        } else {
          Message.error(`${res.data.msg}`)
        }
        this.loading = false
        this.succObj.file = true
      })
    }
  },
  watch: {
    succObj: {
      handler: function (newal, oldal) {
        let a = 0
        for (let i in newal) {
          if (newal[i] === true) {
            a++
          }
        }
        if (a === 5) {
          this.toSpecies()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.species-side-page {
  padding: 11px;
  .header-breadcrumb {
    display: flex;
    margin-bottom: 14px;
    width: 100%;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    .mid-text {
      margin: 0 10px;
    }
    .fir-text {
      color: #666;
      cursor: pointer;
      &:hover {
        color: $theme_color;
      }
    }
  }
  .content {
    background-color: #fff;
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(4, 0, 0, 0.16);
    border-radius: 4px;
    overflow: hidden;
    padding-left: 29px;
    box-sizing: border-box;
    .top {
      margin-top: 21px;
      width: 98%;
      box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.1);
      border-radius: 4px;
      display: flex;
      .top-left {
        margin: 11px 118px 0 23px;
        .up-img {
          width: 423px;
          height: 292px;
          border: 1px dashed #6faae1;
          border-radius: 6px;
          background: #fbfdff;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          div {
            color: #999999;
            font-size: 18px;
            .el-icon-plus {
              font-size: 80px;
            }
          }
          .avatar {
            width: 100%;
            height: 100%;
          }
          &:hover {
            border-color: $theme_color;
          }
        }
        .is-open {
          display: flex;
          align-items: center;
          margin: 20px 0 10px 160px;
          color: #333333;
          font-size: 16px;
          span {
            margin-right: 10px;
          }
        }
      }
      .base-mes {
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
        .base-top {
          width: 68px;
          margin-bottom: 10px;
        }
        .base-title {
          width: 517px;
          background: #f8f8f8;
          height: 34px;
          border-radius: 2px;
          box-sizing: border-box;
          padding-top: 9px;
          padding-left: 14px;
          margin-bottom: 12px;
          span {
            &:last-child {
              margin-left: 83px;
            }
          }
        }
        .base-content {
          box-sizing: border-box;
          padding-left: 16px;
          .el-form {
            >>> .el-form-item {
              margin-bottom: 10px;
              .el-input.is-active .el-input__inner,
              .el-input__inner:focus {
                border-color: $theme_color;
              }
            }
            .genus-item {
              .el-select {
                width: 100%;
                >>> .el-input.is-focus .el-input__inner {
                  border-color: $theme_color;
                }
                &:hover .el-input__inner {
                  border-color: $theme_color;
                }
                >>> .el-select-dropdown {
                  left: 0 !important;
                }
                .el-select-dropdown__item {
                  padding-left: 20px;
                }
              }
            }
          }
        }
      }
    }
    .middle {
      margin-top: 20px;
      width: 98%;
      box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.1);
      border-radius: 4px;
      box-sizing: border-box;
      padding: 28px 19px;
      .inline {
        display: inline-block;
        margin-bottom: 19px;
        margin-right: 70px;
        &:last-child {
          margin-right: 0;
        }
        >>> .el-form-item__content {
          width: 150px;
        }
      }
      .name {
        >>> .el-form-item__content {
          width: 300px;
        }
      }
      .el-form {
        >>> .el-form-item {
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-textarea__inner:focus {
            border-color: $theme_color;
          }
        }
      }
    }
    .download {
      margin-top: 20px;
      width: 98%;
      // height: 250px;
      box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.1);
      border-radius: 4px;
      color: #333333;
      font-size: 16px;
      box-sizing: border-box;
      padding: 14px 26px;
      display: flex;
      justify-content: space-between;
      position: relative;
      // &::after {
      //   position: absolute;
      //   content: '';
      //   display: block;
      //   top: 30px;
      //   left: 50%;
      //   transform: translateX(-50%);
      //   height: 200px;
      //   width: 2px;
      //   background-color: #dddddd;
      // }
      .down-box {
        width: 100%;
        > p {
          display: flex;
          align-items: center;
          margin-bottom: 9px;
          svg {
            margin-left: 5px;
            path {
              fill: #666;
            }
            &:hover {
              path {
                fill: $theme_color;
              }
            }
          }
        }
        .upload {
          .sequence-upload {
            >>> .el-upload {
              width: 100%;
              .el-upload-dragger {
                width: 100%;
                height: 191px;
                &:hover {
                  border-color: $theme_color;
                }
                img {
                  margin-top: 12px;
                }
                .el-upload__text {
                  margin-top: 12px;
                  color: #333333;
                  em {
                    color: $theme_color;
                  }
                }
              }
            }
          }
        }
        .upload-suc {
          width: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          padding: 5px;
          box-sizing: border-box;
          border-radius: 4px;
          .svg-box {
            position: absolute;
            top: 4px;
            right: 8px;
            cursor: pointer;
            .el-icon-circle-close {
              color: #999;
              &:hover {
                color: #e96565;
              }
            }
          }
          img {
            width: 100px;
            margin-bottom: 10px;
          }
          p {
            margin-bottom: 0;
            text-align: center;
            word-break: break-all;
          }
          &:hover {
            background-color: #f8f8f8;
          }
        }
      }
    }
    .reference {
      margin-top: 19px;
      margin-bottom: 30px;
      width: 98%;
      box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.1);
      border-radius: 4px;
      box-sizing: border-box;
      padding: 22px 35px 23px 21px;
      color: #333333;
      font-size: 16px;
      > p {
        margin-bottom: 18px;
      }
      div {
        color: #666666;
        font-size: 14px;
        .reference-list {
          > div {
            position: relative;
            .order-number {
              position: absolute;
              top: 0;
              left: 15px;
              z-index: 1;
              line-height: 33px;
            }
            .el-input {
              overflow: auto;
              >>> .el-input__inner {
                padding-left: 40px;
                border: 1px dashed #fff;
                &:hover {
                  border: 1px dashed #999;
                }
              }
            }
          }
        }
        > .el-input {
          >>> .el-input__inner {
            height: 33px;
            line-height: 33px;
            &:focus {
              border-color: $theme_color;
            }
          }
        }
        .reference-add {
          width: 110px;
          margin-top: 20px;
          cursor: pointer;
          &:hover {
            color: $theme_color;
          }
        }
      }
    }
    button {
      margin-bottom: 19px;
      width: 122px;
      height: 34px;
      background: #175690;
      border-radius: 2px;
      color: #fff;
      font-size: 16px;
      outline: none;
      border: none;
      cursor: pointer;
      &:hover {
        background-color: $theme_color-hover;
      }
    }
  }
  .require {
    position: relative;
    &::after {
      content: '*';
      color: #ff0000;
      position: absolute;
      bottom: 0;
      right: -8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/backstage/species/SpeciesSidePage.vue